<template>
  <Layout ref="main">
    <PageHeader :title="title" :items="items" />
    <div class="row mb-1">
      <div class="col-12 col-md-6 col-lg-6 col-xl">
          <div class="card mb-2 bg-white shadow-none border overflow-hidden rounded-3">
            <div class="card-body py-3">
              <div class="d-flex align-items-center cursor-pointer" @click="changeStatus('pending')">
                  <div class="flex-shrink-0 me-3">
                      <div class="avatar-sm">
                          <div class="avatar-title rounded-circle bg-soft-orange text-orange animate__animated animate__fadeInLeft ">
                            <i class="bi bi-clock-history font-size-24 img-fluid"  ></i>
                          </div>
                      </div>
                  </div>
                  <div class="flex-grow-1 overflow-hidden">
                    <p class="text-body text-truncate mb-0">Pending</p>
                    <div v-if="loading">
                    -
                    </div>
                    <h4 class="m-0 fw-medium font-size-22 text-orange" v-else>
                      <span data-plugin="counterup">
                          <countTo :startVal="0" :endVal="parseFloat(request_and_exchanges_status.pending)" :duration="3000"></countTo>
                      </span>
                    </h4>
                  </div>
              </div>
            </div>
          </div>
      </div>
      
      <div class="col-12 col-md-6 col-lg-6 col-xl">
          <div class="card mb-2 bg-white shadow-none border overflow-hidden rounded-3">
            <div class="card-body py-3">
              <div class="d-flex align-items-center cursor-pointer" @click="changeStatus('approved')">
                  <div class="flex-shrink-0 me-3">
                      <div class="avatar-sm">
                          <div class="avatar-title rounded-circle animate__animated animate__fadeInLeft bg-soft-primary text-primary">
                            <i class="bi bi-list-check font-size-24 img-fluid"></i>
                          </div>
                      </div>
                  </div>
                  <div class="flex-grow-1 overflow-hidden">
                    <p class="text-body text-truncate mb-0">Approved</p>
                    <div v-if="loading">
                    -
                    </div>
                    <h4 class="m-0 fw-medium font-size-22 text-primary" v-else>
                      <span data-plugin="counterup">
                          <countTo :startVal="0" :endVal="parseFloat(request_and_exchanges_status.approved)" :duration="3000"></countTo>
                      </span>
                    </h4>
                  </div>
              </div>
            </div>
          </div>
      </div>

      <div class="col-12 col-md-6 col-lg col-xl">
          <div class="card mb-2 bg-white shadow-none border overflow-hidden rounded-3">
            <div class="card-body py-3">
              <div class="d-flex align-items-center cursor-pointer" @click="changeStatus('processing')">
                  <div class="flex-shrink-0 me-3">
                      <div class="avatar-sm">
                          <div class="avatar-title rounded-circle animate__animated animate__fadeInLeft bg-soft-blue text-blue">
                            <i class="bi bi-hourglass-split font-size-24 img-fluid"></i>
                          </div>
                      </div>
                  </div>
                  <div class="flex-grow-1 overflow-hidden">
                    <p class="text-body text-truncate mb-0">Processing</p>
                    <div v-if="loading">
                    -
                    </div>
                    <h4 class="m-0 fw-medium font-size-22 text-blue" v-else>
                      <span data-plugin="counterup">
                          <countTo :startVal="0" :endVal="parseFloat(request_and_exchanges_status.processing)" :duration="3000"></countTo>
                      </span>
                    </h4>
                  </div>
              </div>
            </div>
          </div>
      </div>

      <div class="col-12 col-md-6 col-lg col-xl">
          <div class="card mb-2 bg-white shadow-none border overflow-hidden rounded-3">
            <div class="card-body py-3">
              <div class="d-flex align-items-center cursor-pointer" @click="changeStatus('completed')">
                  <div class="flex-shrink-0 me-3">
                      <div class="avatar-sm">
                          <div class="avatar-title rounded-circle animate__animated animate__fadeInLeft bg-soft-purple text-purple">
                            <i class="bi bi-check-circle font-size-24 img-fluid"></i>
                          </div>
                      </div>
                  </div>
                  <div class="flex-grow-1 overflow-hidden">
                    <p class="text-body text-truncate mb-0">Completed</p>
                    <div v-if="loading">
                    -
                    </div>
                    <h4 class="m-0 fw-medium font-size-22 text-purple" v-else>
                      <span data-plugin="counterup">
                          <countTo :startVal="0" :endVal="parseFloat(request_and_exchanges_status.completed)" :duration="3000"></countTo>
                      </span>
                    </h4>
                  </div>
              </div>
            </div>
          </div>
      </div>

      <div class="col-6 col-md-12 col-lg col-xl">
          <div class="card mb-2 bg-white shadow-none border overflow-hidden rounded-3">
            <div class="card-body py-3">
              <div class="d-flex align-items-center cursor-pointer" @click="changeStatus('rejected')">
                  <div class="flex-shrink-0 me-3">
                      <div class="avatar-sm">
                          <div class="avatar-title rounded-circle animate__animated animate__fadeInLeft bg-soft-danger text-danger">
                            <i class="bi bi-x-circle font-size-24 img-fluid"></i>
                          </div>
                      </div>
                  </div>
                  <div class="flex-grow-1 overflow-hidden">
                    <p class="text-body text-truncate mb-0">Rejected</p>
                    <div v-if="loading">
                    -
                    </div>
                    <h4 class="m-0 fw-medium font-size-22 text-danger" v-else>
                      <span data-plugin="counterup">
                          <countTo :startVal="0" :endVal="parseFloat(request_and_exchanges_status.rejected)" :duration="3000"></countTo>
                      </span>
                    </h4>
                  </div>
              </div>
            </div>
          </div>
      </div>
      <!-- end col-->
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card border rounded-3 shadow-none" id="card_section">
          <div class="card-title p-3 rounded-top custom-page-header">
            <div class="d-lg-flex align-items-center">
              <div class="d-flex align-items-center mb-2 mb-lg-0">
                <div class="me-2">
                  <i class="bi bi-arrow-left-right font-size-24"></i>
                </div>
                <div class="">
                  <h4 class="fw-medium font-size-20 mb-0">
                    {{ title }} -  <span class="text-capitalize">{{ status }}</span>
                  </h4>
                  <small class="d-block font-size-13 fw-normal">Easily return or exchange items within our policy for a hassle-free experience.</small>
                </div>
              </div>

              <div class="ms-auto" v-if="create_modify_permission">
                  <button class="btn btn-primary fw-medium" v-if="create_modify_permission" @click="createUser"><i class="uil uil-plus font-size-16 me-1 text-white"></i>  New Request</button>
                </div>
            </div>
          </div>
          
          <div class="card-body">
           
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6 col-xl mb-2">
                <label class="form-label mb-1">Keyword</label>
                <input
                    type="text"
                    placeholder="ID, Username, Merchant Name, Company Name"
                    class="form-control"
                    :disabled="disabled"
                    v-model.trim="searchKeyword"
                  />
              </div>
              <div class="col-12 col-md col-lg-6 col-xl-4 mb-3">
                <label class="form-label mb-1">Date Range</label>
                <date-picker
                  v-model="date_range"
                  type="date"
                  range
                  value-type="format" 
                  format="YYYY-MM-DD"
                  placeholder="Select Date Range"
                  :disabled="disable_date"
                  :disabled-date="notBeforeToday"
                  :clearable="false"
                  :editable="false"
                  :shortcuts="shortcuts"
                  class="mb-0"
                ></date-picker>
                
              </div>
             
              
              <div class="col-12 col-md-auto col-xl-auto">
                <label class="form-label mb-1 d-md-block d-none">&nbsp;</label>
                <div class="row">
                  <div class="col-6 pe-1 col-auto d-grid">
                    <button
                      class="btn btn-light mb-3 text-nowrap"
                      type="button"
                      :disabled="disabled"
                      @click="clear()"
                    >
                      <i class="uil-redo me-1"></i> Clear
                    </button>
                  </div>
                  <div class="col-6 ps-1 col-auto d-grid">
                    <button
                      class="btn btn-primary text-white mb-3 text-nowrap"
                      type="button"
                      :disabled="disabled"
                      @click="search()"
                    >
                      <i class="uil-search me-1"></i> Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
           
            <div class="table-responsive text-nowrap font-size-14 position-relative">
              <!-- <div class="position-relative">
                <b-button id="tooltip-button-interactive">My tooltip is interactive</b-button>
                <b-tooltip target="tooltip-button-interactive">I will stay open when hovered</b-tooltip>
              </div> -->
              <table id="freeze" class="table mt-2 mb-0 align-middle min-width-760" :class="{'table-hover':returnData.length>0 && !pageLoading}" ref="table">
                <thead class="text-uppercase">
                  <tr>
                    <th>ID</th>
                    <th>Company</th>
                    <th>Merchant</th>
                    <th>Title</th>
                    <th>Submitted Document</th>
                    <th>Status</th>
                    <th>Created At</th>
                    <th>Updated At</th>
                    <th>Updated By</th>
                    <th class="text-center" v-if="create_modify_permission">Actions</th>
                  </tr>
                </thead>
                <tbody class="text-muted">
                  <tr v-if="!returnData.length && !pageLoading">
                    <td :colspan="returnColSpan()" height="300" class="text-center text-muted">
                      No Data Available
                    </td>
                  </tr>
                  <tr v-if="pageLoading">
                    <td :colspan="returnColSpan()" class="text-center text-muted" height="400">
                      <div
                        class="spinner-border text-secondary my-2"
                        role="status"
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                      <br />
                      <div>Loading...</div>
                    </td>
                  </tr>
                  
             
                  <tr v-for="(value, index) in returnData" :key="index" v-show="!pageLoading" >
                    <td>
                        {{ value.return_exchanges_id }}
                    </td>
                    <td> 
                      <router-link
                        class="fw-medium"
                        v-b-tooltip.hover
                        :to="{
                           name: 'Edit Merchant',
                           params: { id: value.account_db_code },
                        }"
                        > {{ value.company_name }}</router-link
                        > 
                     
                    </td>
                    <td> 
                      <router-link
                        class="fw-medium"
                        v-b-tooltip.hover
                        :to="{
                           name: 'Edit Merchant',
                           params: { id: value.account_db_code },
                        }"
                        > {{ value.first_name }}  {{ value.last_name }}</router-link
                        > 
                     
                    </td>
                    <td class="text-wrap" style="min-width: 200px;"> 
                      {{ value.title }}
                    </td>
                    <td> 
                      <a :href="value.document_1" class="fw-medium" title="Complaint Record Form">Complaint Record Form</a>
                    </td>
                    <td> 
                      <div>
                        <span v-if="value.status=='pending'" class="text-orange badge border border-orange fw-medium font-size-13 text-capitalize text-uppercase">{{value.status}}</span>
                        <span v-if="value.status=='approved'" class="text-primary badge border border-primary fw-medium font-size-13 text-capitalize text-uppercase">{{value.status}}</span>
                        <span v-if="value.status=='processing'" class="text-blue badge border border-blue fw-medium font-size-13 text-capitalize text-uppercase">{{value.status}}</span>
                        <span v-if="value.status=='completed'" class="text-success badge border border-success fw-medium font-size-13 text-capitalize text-uppercase"> {{value.status}}</span>
                        <span v-if="value.status=='rejected'" class="text-danger badge border border-danger fw-medium font-size-13 text-capitalize text-uppercase" v-b-tooltip.hover :title="value.rejected_reason"> {{value.status}}</span>
                      </div>
                    </td>
                    <td> 
                      {{value.created_at}} 
                    </td>
                    <td> 
                      {{value.updated_at || '-'}} 
                    </td>  
                    <td>
                      {{ value.approved_by || '-' }}
                    </td>
                    <td class="text-center" v-if="create_modify_permission">
                      <button class="btn btn-lg custom-button rounded-pill p-2 lh-1 me-2" @click="editUser(value)">
                        <i class="bi bi-pencil-square"></i>
                      </button>
                      <button type="button" @click="remove(value)" v-b-tooltip.hover title="Delete" class="btn btn-lg custom-button rounded-pill p-2 lh-1">
                        <i class="bi bi-trash"></i> 
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row" v-if="returnData.length">
              <div class="col mt-3">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      hide-ellipsis
                      @change="handlePageChange"
                      v-model="currentPage"
                      :per-page="perPage"
                      :total-rows="totalData"
                    >
                    </b-pagination>
                  </ul>
                </div>
              </div>
            </div>
           
          </div>
        </div>
      </div>
    </div>

    <otherModal ref="modalFunc2" :data="{accessUsername:accessUsername, assessToken:accessToken, updateData:updateData}" @callParentFunction="fromChildFunction"/> 
  
    <Common ref="commonFunc"/>
  </Layout>
</template>

<script>
import countTo from "vue-count-to";
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Common from "@/components/common";
import axios from "axios";
import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";
import otherModal from "@/views/pages/app/modal/otherModal";
/**
 * Page
 */
const PageTitle = "Returns & Exchanges";
const groupDefault = { "id": "", "account_db_code": "", "name": "Selet Group" };
export default {
  components: {
    Layout,
    PageHeader,
    Common,
    DatePicker,
    otherModal,
    countTo
  },
  page() {
    return {
      title: PageTitle,
      meta: [
        {
          name: "description",
          content: appConfig.description,
        },
      ],
    }
  },
  data() {
    return {
      updateData:{},
      accessToken: '',
      accessEmail: '',
      accessPhone: '',
      accessUsername: '',
      account_type: '',
      showLottie: false,
      title: '',
      items: [
        {
          text: appConfig.pageTitle,
          to: "/",
        },
        {
          text: '',
          active: true,
        },
      ],
      formData: {
        apiID: "YOUR_API_ID",
        apiHash: "YOUR_API_HASH",
      },
      submitted: false,
      loading: false,
      pageLoading: false,
      buttonLoading: [false, false, false],
      currentPage: 1,
      seletedMethod: "",
      sortBy: "",
      status: "",
      paymentStatus: "",
      searchKeyword: "",
      groupSelected: groupDefault,
      groups:[],
      searchMerchantItemId: "",
      filterType: "created_date",
      searchAmount: "",
      perPage: 20,
      totalData: 0,
      returnData: [],
      returnPaidTotal: 0,
      returnPayoutProcessed: 0,
      export_data: [],
      search_value: "",
      disableExport: false,
      loadingButton: false,
      date_range: null,
      disable_date: false,
      disabled: false,
      shortcuts: [],
      create_modify_permission: false,
      request_and_exchanges_status:{
        pending:0,
        approved:0,
        processing:0,
        completed:0,
        rejected:0
      }

    };
  },
  middleware: "authentication",
  async mounted() {
    await this.reload()
    this.title = PageTitle
    this.items[1].text = PageTitle
    this.accessToken = this.$refs.commonFunc.getToken()
    this.accessUsername = this.$refs.commonFunc.getUsername()
    this.date_range = this.$refs.commonFunc.last30Days()
    this.shortcuts = this.$refs.commonFunc.datePickerShortcut()
    //this.getGroups();
    await this.changeStatus();
    //await this.handlePageChange(1);

  },
  created() {

  },
  methods: {
    fromChildFunction:function(e){
     console.log(e)
      this.changeStatus(e)
    },
    changeStatus(value){
      //replace query first
      if (value){
        this.$router.replace({query:{status: value}}).catch(() => {});
      }
    
      if (this.$route.query.status){
        if (this.$route.query.status=='pending'){
          this.status='pending'
        }
        else if (this.$route.query.status=='approved'){
          this.status='approved'
        }
        else if (this.$route.query.status=='processing'){
          this.status='processing'
        }
        else if (this.$route.query.status=='completed'){
          this.status='completed'
        }
        else if (this.$route.query.status=='rejected'){
          this.status='rejected'
        }
        else{
          this.status='pending'
          this.$router.replace({query:{status: 'pending'}}).catch(() => {});
        }
      }else{
        this.status='pending'
        this.$router.replace({query:{status: 'pending'}}).catch(() => {});
      }
      
      this.currentPage = 1
      this.handlePageChange(1);
    },
    returnColSpan() {
      const table = this.$refs.table;
      if (table){
        const columns = table.querySelectorAll('th');
        return columns.length;
      }
    },
    resetPassword(value){
     this.updateData = value;
     this.updateData.fromType = "merchantResetPassword" 
     setTimeout(() =>  this.$refs.modalFunc2.showMerchantResetPassword(),100)
    },
    getGroups() {
      console.log("getGroups")
      this.$Progress.start();
      this.loading = true
      this.disabled = true
      var bodyFormData = new FormData();
      bodyFormData.append("accessToken", this.accessToken);
      bodyFormData.append("accessUsername", this.accessUsername);
      axios({
        method: "get",
        url: "/api/group_pricing_setting.json",
        data: bodyFormData,
        headers: {
          "Content-Type": "multipart/form-data"
        },
      }).then((response) => {
        var resData = response.data;
        if (resData.status == 200) {
          this.groups = []
          this.groups = [groupDefault];
          //this.groups=resData.data;
          resData.data.forEach(element => {
            this.groups.push({
              id: element.id,
              account_db_code: element.account_db_code,
              name: element.name
            })
          });

        } else if (resData.status == 440) {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            html: `${resData.message}.`,
            confirmButtonColor: '#222',
            confirmButtonText: this.$t('siteLang.Done'),
          })
          localStorage.clear();
          this.$router.push({
            path: "/login",
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            html: `${resData.message}.`,
            confirmButtonColor: '#222',
            confirmButtonText: this.$t('siteLang.Done'),
          })
        }
        this.loading = false;
        this.disabled = false
        this.$Progress.finish();
      }).catch((error) => {
        this.loading = false;
        this.disabled = false
        this.$Progress.finish();
        //Swal.fire("Error", error, "error");
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          html: `${error}.`,
          confirmButtonColor: '#222',
          confirmButtonText: this.$t('siteLang.Done'),
        })
      });
    },
    convertCurrencyFormat(value, show00) {
      if (show00 == true) {
        return this.$refs.commonFunc.convertCurrencyFormat(value)
      } else {
        // Assuming this.transactionLimit is defined in your component's data
        return this.$refs.commonFunc.convertCurrencyFormat(value).replaceAll(".00", "");
      }
    },
    notBeforeToday(date) {
      return date > new Date(new Date().setHours(0, 0, 0, 0));
    },
    DateChanged() {
      console.log("datechange" + this.date_range);
      this.handlePageChange(1);
      this.currentPage = 1;
      this.disable_date = true;
    },
    handlePageChange(current_page) {
      this.pageNum = current_page;
      this.currentPage = current_page;
      this.getData(this.pageNum, this.searchKeyword);
      //this.exportData(1)
    },
    search() {
      this.handlePageChange(1);
      this.currentPage = 1;
    },
    clear() {
      this.sortBy = ""
      this.searchKeyword = ""
      this.filterType = "created_date"
      this.date_range = this.$refs.commonFunc.last30Days()
      this.handlePageChange(1);
      this.currentPage = 1;
    },

    exportToExcel(Data, name, type) {
      var title = name.replace(/ /g, "_");
      var ws = window.XLSX.utils.json_to_sheet(Data);
      let objectMaxLength = [];
      for (let i = 0; i < Data.length; i++) {
        let value = Object.values(Data[i]);
        for (let j = 0; j < value.length; j++) {
          if (typeof value[j] == "number") {
            objectMaxLength[j] = 5;
          } else {
            objectMaxLength[j] =
              objectMaxLength[j] >= value[j].length
                ? parseInt(objectMaxLength[j])
                : parseInt(value[j].length) + 5;
          }
        }
      }
      var wscols = []
      objectMaxLength.forEach((value, index) => {
        console.log(value)
        wscols.push({ width: objectMaxLength[index] })
      }),
        ws['!cols'] = wscols;

      var wb = window.XLSX.utils.book_new();
      window.XLSX.utils.book_append_sheet(wb, ws, name)
      window.XLSX.writeFile(wb, title + '.' + (type || 'xlsx'))
    },
    async getData(pages, keyword) {
      this.$Progress.start();
      this.pageLoading = true
      this.disabled = true
      this.disable_date = true;
      this.returnData = [];
      var bodyFormData = new FormData();
      bodyFormData.append("accessToken", this.accessToken);
      bodyFormData.append("accessUsername", this.accessUsername);
      bodyFormData.append("page", pages);
      bodyFormData.append("limit", this.perPage);
      bodyFormData.append("keyword", keyword);
      bodyFormData.append("status", this.status);
      bodyFormData.append("paymentStatus", this.paymentStatus);
      bodyFormData.append("dateStart", this.date_range[0]);
      bodyFormData.append("dateEnd", this.date_range[1]);
      bodyFormData.append("merchantDbCode", "");
      console.log(`page:${pages}, limit:${this.perPage}, keyword:${keyword}, status:${this.status}, paymentStatus:${this.paymentStatus}, dateStart:${this.date_range[0]}, dateEnd:${this.date_range[1]}`)
      axios({
        method: "get",
        url: `/api/returns_&_exchanges.json`,
        // method: "post",
        // url: appConfig.APIHost + 'controller/applicant/getAllApplicantList',
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          this.returnData = [];
          var resData = response.data;
          this.totalData = resData.total
          var responseData = resData.data

          if (resData.status == 200) {
            //testing start
            this.returnData = responseData.filter(e =>e.status===this.status);
            //testing end
            
            this.request_and_exchanges_status={
              pending:1,
              approved:1,
              processing:1,
              completed:0,
              rejected:1
            }
          }
          else if (resData.status == 440) {
            Swal.fire(
              {
                icon: 'error',
                title: 'Oops...',
                html: `${resData.message}.`,
                confirmButtonColor: '#222',
                confirmButtonText: this.$t('siteLang.Done'),
              })
            localStorage.clear();
            this.$router.push({
              path: "/login",
            });
          }
          else {
            Swal.fire(
              {
                icon: 'error',
                title: 'Oops...',
                html: `${resData.message}.`,
                confirmButtonColor: '#222',
                confirmButtonText: this.$t('siteLang.Done'),
              })
          }
          setTimeout(() => {
            this.pageLoading = false;
          this.disabled = false
          this.disable_date = false;
          this.$Progress.finish();
          }, 1000);
        
        })
        .catch((error) => {
          this.pageLoading = false;
          this.disabled = false
          this.disable_date = false;
          this.$Progress.finish();
          //Swal.fire("Error", error, "error");
          Swal.fire(
            {
              icon: 'error',
              title: 'Oops...',
              html: `${error}.`,
              confirmButtonColor: '#222',
              confirmButtonText: this.$t('siteLang.Done'),
            })
        });
    },
    createUser(){
      setTimeout(() =>  this.$refs.modalFunc2.showModal(),100)
    },
    editUser(value){
      this.updateData=value;
      setTimeout(() =>  this.$refs.modalFunc2.showEditModal(),100)
    },
    remove(value) {
      Swal.fire({
        icon: 'info',
        title: 'Delete this request?',
        html: `
          <p class="mb-0">Are you sure you want to delete this return and exchange request?</p>
        `,
        confirmButtonColor: '#FA6541',
        iconColor: '#60b725',
        showCancelButton: true,
        confirmButtonText: "Yes"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$Progress.start();
          this.loading = true
          this.disabled = true
          var bodyFormData = new FormData();
          bodyFormData.append("accessToken", this.accessToken);
          bodyFormData.append("accessUsername", this.accessUsername);
          bodyFormData.append("accountDbCode", value.account_db_code);
          axios({
            method: "post",
            url: appConfig.StagingAPI + "controller/applicant/deleteApplicant",
            data: bodyFormData,
            headers: {
              "Content-Type": "multipart/form-data"
            },
          }).then((response) => {
            this.returnData = []
            var resData = response.data;
            if (resData.status == 200) {
              console.log(resData)
              this.handlePageChange(1)
              Swal.fire({
                icon: 'success',
                title: `${value.company_name} Deleted Successfully`,
                html: 'The selected applicant has been successfully deleted.',
                confirmButtonColor: '#FA6541',
                confirmButtonText: this.$t('siteLang.Done')
              })
            } else if (resData.status == 440) {
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                html: `${resData.message}.`,
                confirmButtonColor: '#222',
                confirmButtonText: this.$t('siteLang.Done'),
              })
              this.$refs.commonFunc.clearData()
              this.$router.push({
                path: "/login",
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                html: `${resData.message}.`,
                confirmButtonColor: '#222',
                confirmButtonText: this.$t('siteLang.Done'),
              })
            }
            this.loading = false
            this.disabled = false
            this.$Progress.finish();
          }).catch((error) => {
            this.disabled = false;
            this.loading = false
            this.$Progress.finish();
            //Swal.fire("Error", error, "error");
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              html: `${error}.`,
              confirmButtonColor: '#222',
              confirmButtonText: this.$t('siteLang.Done'),
            })
          });
        }
      })


    },
    async exportData() {
      this.$Progress.start();
      this.disableExport = true;
      this.loadingButton = true;
      var bodyFormData = new FormData();
      bodyFormData.append("accessToken", this.accessToken);
      bodyFormData.append("phone", this.accessPhone);
      // bodyFormData.append("page", pages);
      // bodyFormData.append("limit", this.perPage);
      axios({
        method: "get",
        url: `https://dummyjson.com/users/search?q=&limit=100&skip=1`,
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          this.export_data = [];
          var resData = response.data;
          this.totalData = resData.total
          var users = resData.users


          for (var i in users) {
            // Combine date and time
            const depositDateTime = `29 Jun 2023, 12:30:00`;
            // Generate a random deposit amount
            const randomDeposit = Math.floor(Math.random() * 10000) + 1000; // Random amount between 1000 and 11000

            // Calculate merchant fee and nett amount
            const merchantFeePercentage = 2.5 / 100; // 2.5% merchant fee
            const merchantFee = Math.floor(randomDeposit * merchantFeePercentage);
            const nettAmount = randomDeposit - merchantFee;
            const randomStatus = Math.random() < 0.8 ? "success" : "failed";
            var randomMode = Math.random() < 0.8 ? "UPI" : "IMPS";
            var transaction_id = ""
            if (randomMode == "UPI") {
              transaction_id = "320020673657"
            } else {
              transaction_id = "IMPS/123443211240"
            }

            const listData = {
              "id": "ids",
              "deposit_date": depositDateTime,
              "customer_id": `${users[i].id}`,
              "customer_name": `${users[i].firstName} ${users[i].lastName}`,
              "deposit_amount": randomDeposit.toString(),
              "deposit_mode": randomMode.toString(),
              "merchant_fee": merchantFee.toString(),
              "nett_amount": nettAmount.toString(),
              "transaction_id": transaction_id,
              "status": randomStatus,
            };
            this.export_data.splice(i, 0, listData);
          }
          var self = this
          setTimeout(function () {
            self.disableExport = false;
            self.loadingButton = false;
            self.exportToExcel(self.export_data, 'Summary', 'xlsx')
          }, 1200);

          // if (resData.status == 200) {
          //   console.log(resData)
          //   this.totalData = 10
          // } 
          // else if (resData.status == 440){
          //   Swal.fire(
          //       {
          //       icon: 'error',
          //       title: 'Oops...',
          //       html: `${resData.message}.`,
          //       confirmButtonColor: '#222',
          //       confirmButtonText: this.$t('siteLang.Done'),
          //     })
          //     localStorage.clear();
          //     this.$router.push({
          //         path: "/login",
          //   });
          // }
          // else {
          //     Swal.fire(
          //       {
          //       icon: 'error',
          //       title: 'Oops...',
          //       html: `${resData.message}.`,
          //       confirmButtonColor: '#222',
          //       confirmButtonText: this.$t('siteLang.Done'),
          //     })
          // }
          this.loading = false;
          this.$Progress.finish();
        })
        .catch((error) => {
          this.disableExport = false;
          this.loadingButton = false;
          this.loading = false;
          this.$Progress.finish();
          //Swal.fire("Error", error, "error");
          Swal.fire(
            {
              icon: 'error',
              title: 'Oops...',
              html: `${error}.`,
              confirmButtonColor: '#222',
              confirmButtonText: this.$t('siteLang.Done'),
            })
        });
    },
    async reload() {
      try {
        await this.$nextTick(); // Wait for the component to be fully mounted

        const commonFunc = this.$refs.commonFunc;
        if (commonFunc && commonFunc.getFullData) {
          const data = await commonFunc.getFullData();
          this.account_type = data.account_type//data.account_type;
          const permission = data.modules.filter(e => e.name === 'returns_&_exchanges')
          if (permission) {
            this.create_modify_permission = permission[0].create_modify_permission == 0 ? false : true;
          } else {
            console.log('Module with name "returns_&_exchanges" not found.');
          }
        } else {
          // Handle the case when commonFunc or getFullData is undefined
          // Perform appropriate actions or show a fallback message to the user
        }
      } catch (error) {
        // Handle the error silently without propagating it further
      }
    },
  }
};
</script>
<style scoped>
.light-green{
  color: #6be917;
}
</style>